export default "__VITE_ASSET__CSDP9Clb__"